import styled from 'styled-components'
import { BREAK_POINT_SM } from '@CSSVars/variables'

export const _SliderContainer = styled.div`
  width: 100%;
  max-width: 310px;
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    max-width: 100%;
    min-width: initial;
  }
`
export const _DatePickerContainer = styled.div`
  display: flex;
  position: relative;
  @media screen and (max-width: 63.9em) {
    position: relative;
    width: 100%;

  }

`

export const _DropdownContainer = styled.div`
  width: ${({ periodDropdown }) => (periodDropdown ? '155' : '212')}px;
  max-width: ${({ periodDropdown }) => (periodDropdown ? '155' : '212')}px;
  margin-right: ${({ periodDropdown }) => (periodDropdown ? '0' : '12')}px;
  ${({ periodDropdown }) => (periodDropdown && `
    > div {
      margin: 0;
    }
  `)};
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    ${({ periodDropdown }) => (!periodDropdown && `
      width: 100%;
      max-width: initial;
    `)}
  }
`
